import {Component, input} from '@angular/core';
import {VideoGridElement} from './video-grid-element.model';
import {SafeUrlPipe} from '../../_pipes/safe-url.pipe';

@Component({
  selector: 'app-videos-grid',
  standalone: true,
  imports: [
    SafeUrlPipe
  ],
  templateUrl: './videos-grid.component.html',
  styleUrl: './videos-grid.component.scss'
})
export class VideosGridComponent {
  videos = input.required<VideoGridElement[]>();
}
